import { ICinemaPalette } from '../palette';
import { IMiniGamePalette } from './types';
import { MINI_GAMES_MUTED_KEY } from './constants';

export const TOUCH_PRIMARY_QUERY = '(hover: none) and (pointer: coarse)';
export const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

export const toMiniGamePalette = (
  palette: ICinemaPalette,
): IMiniGamePalette => ({
  accent: palette.buttonBackgroundColor,
  accentHover: palette.buttonHoverColor,
  accentHi: palette.accentHi,
  accentGlow: palette.accentGlow,
  link: palette.linkColor,
  linkHi: palette.linkHi,
  ink: palette.ctaInk,
  text: palette.pageTextColor,
});

export const matchesMedia = (query: string): boolean =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia(query).matches;

export const isTouchPrimary = () => matchesMedia(TOUCH_PRIMARY_QUERY);

export const prefersReducedMotion = () => matchesMedia(REDUCED_MOTION_QUERY);

export const readMuted = (): boolean => {
  try {
    return window.localStorage.getItem(MINI_GAMES_MUTED_KEY) === 'true';
  } catch {
    return false;
  }
};

export const writeMuted = (muted: boolean) => {
  try {
    window.localStorage.setItem(MINI_GAMES_MUTED_KEY, String(muted));
  } catch {
    return;
  }
};

export const keepFocus = (event: { preventDefault: () => void }) =>
  event.preventDefault();

export const logoUrlOf = (customerLogo: unknown): string | null =>
  typeof customerLogo === 'string' && customerLogo ? customerLogo : null;
